import { createContext, useContext, useState, useEffect } from 'react';
import { translations, getTranslation, availableLanguages } from '../utils/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get from localStorage or default to English
    return localStorage.getItem('decoded_language') || 'en';
  });

  useEffect(() => {
    // Save to localStorage when language changes
    localStorage.setItem('decoded_language', language);
    // Update document lang attribute for accessibility
    document.documentElement.lang = language;
  }, [language]);

  // Translation function
  const t = (key) => getTranslation(language, key);

  // Change language function
  const changeLanguage = (langCode) => {
    if (availableLanguages.some(l => l.code === langCode)) {
      setLanguage(langCode);
    }
  };

  const value = {
    language,
    setLanguage: changeLanguage,
    t,
    translations: translations[language] || translations['en'],
    availableLanguages
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
